var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "men\\xFA",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_37",
    "data-name": "Rect\\xE1ngulo 37",
    width: 20.375,
    height: 16.379,
    transform: "translate(0 0)",
    fill: "black"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_38",
    "data-name": "Rect\\xE1ngulo 38",
    width: 24,
    height: 24,
    fill: "black",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_40",
    "data-name": "Grupo 40",
    transform: "translate(2 4)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_33",
    "data-name": "Trazado 33",
    d: "M19.625,14.879H.75a.75.75,0,0,0,0,1.5H19.625a.75.75,0,0,0,0-1.5",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_34",
    "data-name": "Trazado 34",
    d: "M19.625,7.44H.75a.75.75,0,1,0,0,1.5H19.625a.75.75,0,1,0,0-1.5",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_35",
    "data-name": "Trazado 35",
    d: "M.75,1.5H19.625a.75.75,0,0,0,0-1.5H.75a.75.75,0,0,0,0,1.5",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuWhite);
export default __webpack_public_path__ + "static/media/menuWhite.f7d5b689127eab7e343b8a26e02cac8b.svg";
export { ForwardRef as ReactComponent };